import { CommonModule } from '@angular/common';
import { Component, OnInit, Input } from '@angular/core';
import {
  ControlContainer,
  FormsModule,
  NgForm,
  ReactiveFormsModule
} from '@angular/forms';
import { TextMaskModule } from 'angular2-text-mask';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzInputModule } from 'ng-zorro-antd/input';
import { IHealthCard } from '@care-portals/api-interfaces';

type HealthCardType = 'Ontario' | 'Non-Ontario';

@Component({
  selector: 'common-health-card',
  templateUrl: './health-card.component.html',
  styleUrls: ['./health-card.component.less'],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
  standalone: true,
  imports: [
    CommonModule,
    NzFormModule,
    FormsModule,
    ReactiveFormsModule,
    NzInputModule,
    NzButtonModule,
    TextMaskModule,
    NzFormModule
  ]
})
export class CommonHealthCardComponent implements OnInit {
  @Input('hcType') hcType: HealthCardType;
  @Input('data') data: IHealthCard;

  constructor() {}

  dateMask = [/\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/];

  ngOnInit(): void {
    if (!this.data) {
      this.data['hcType'] = this.hcType;
      this.data['hcNum'] = '';
      if (this.hcType === 'Ontario') {
        this.data['hcVer'] = '';
      }
      this.data['hcEff'] = '';
      this.data['hcExp'] = '';
    } else {
      this.data['hcType'] = this.hcType;
    }
  }
}
